













import Vue from 'vue';

export default Vue.extend({
  name: 'HHeroll',
  props: {
    size: {
      type: String,
      default: 'medium',
      validator(value) {
        // The value must match one of these strings
        return ['small', 'big', 'medium'].indexOf(value) !== -1;
      },
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    componentSize() {
      const cls = ['heroll', `heroll--${this.size}`];
      if (this.dark) {
        cls.push('heroll--dark');
      }

      return cls;
    },
  },
});
